
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/sign_in",
      function () {
        return require("private-next-pages/auth/sign_in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/sign_in"])
      });
    }
  